import { alpha } from '@mui/material/styles';

/**
 * Crea tokens de color semánticos para el chat basados en el tema
 *
 * @param {Object} theme - MUI theme object
 * @returns {Object} Chat color tokens
 */
export const createChatColorTokens = (theme) => {
  const isDark = theme.palette.mode === 'dark';

  // Usar colores de los theme presets (todos los presets los definen)
  // Fallback a background.paper — neutro, no tintado
  const userBg = isDark
    ? (theme.sections?.chat?.userMessageBg || '#1E40AF')
    : (theme.sections?.chat?.userMessageBg || '#E3F2FD');

  const agentBg = isDark
    ? (theme.sections?.chat?.botMessageBg || theme.palette.background.paper)
    : (theme.sections?.chat?.botMessageBg || theme.palette.background.paper);

  return {
    // Fondos de mensajes - Sincronizados con theme presets
    messages: {
      user: {
        background: userBg,
        text: theme.palette.text.primary
      },
      agent: {
        background: agentBg,
        text: theme.palette.text.primary,
        borderColor: isDark
          ? alpha(theme.palette.primary.light || theme.palette.primary.main, 0.18)
          : alpha(theme.palette.primary.main, 0.1)
      }
    },

    // Avatares
    avatars: {
      textColor: theme.palette.primary.contrastText,
      fallbackBg: theme.palette.primary.main
    },

    // Indicador de escritura
    typing: {
      background: theme.palette.background.default,
      dotColor: theme.palette.primary.main
    },

    // Estilos de markdown
    markdown: {
      // Code inline
      codeInline: {
        background: isDark
          ? alpha(theme.palette.common.white, 0.1)
          : alpha(theme.palette.common.black, 0.05),
        text: theme.palette.text.primary
      },

      // Code blocks (pre)
      codeBlock: {
        background: isDark
          ? alpha(theme.palette.common.white, 0.05)
          : alpha(theme.palette.common.black, 0.03),
        text: theme.palette.text.primary
      },

      // Blockquotes
      blockquote: {
        borderColor: isDark
          ? alpha(theme.palette.common.white, 0.2)
          : theme.palette.grey[400],
        text: theme.palette.text.secondary
      },

      // Tablas
      table: {
        border: theme.palette.divider,
        headerBg: isDark
          ? alpha(theme.palette.common.white, 0.05)
          : alpha(theme.palette.common.black, 0.03),
        rowBorderStrong: theme.palette.divider,
        rowBgEven: isDark
          ? alpha(theme.palette.common.white, 0.02)
          : alpha(theme.palette.common.black, 0.01)
      },

      // Links
      link: {
        color: theme.palette.primary.main,
        decoration: 'underline'
      },

      // Separador horizontal
      hr: {
        color: theme.palette.divider
      }
    }
  };
};
